import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_child_info_page = _resolveComponent("child-info-page")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.documentBreadcrumbItems
      }, null, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.child)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        size: "x-large",
        variant: "flat",
        color: "primary",
        onClick: _ctx.save,
        disabled: _ctx.isSaving
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isSaving || _ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "1" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Basic Info", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "2" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Lifestyle Info", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "3" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Health & Development Info", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_child_info_page, {
              elements: _ctx.basicInfo,
              onUpdateInfo: _ctx.updateBasicInfo
            }, null, 8, ["elements", "onUpdateInfo"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_child_info_page, {
              elements: _ctx.lifeStyleInfo,
              onUpdateInfo: _ctx.updateLifestyleInfo
            }, null, 8, ["elements", "onUpdateInfo"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_child_info_page, {
              elements: _ctx.healthInfo,
              onUpdateInfo: _ctx.updateHealthInfo
            }, null, 8, ["elements", "onUpdateInfo"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}